export interface RatingScoreInterface{
    key: Number;
    value: String;
}

export const RatingScore: RatingScoreInterface[] = [
    {key: 0, value: 'Pontuação até 5 estrelas'},
    {key: 1, value: 'Padrão NPS'},
]